import { inject, Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { catchError, EMPTY, Observable, throwError } from 'rxjs';
import { TokenService } from '@libs/shared-services';
import { ErrorCode } from '@ffd/api-client';

@Injectable({ providedIn: 'root' })
export class UnauthorizedInterceptorService implements HttpInterceptor {
  public tokenService = inject(TokenService);

  public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: unknown) => {
        if (this.isAuthFailedError(error) && this.tokenService.getAccessToken()) {
          this.tokenService.logout();
          return EMPTY;
        }
        return throwError(() => error);
      }),
    );
  }

  private isUnauthorizedError(error: unknown): boolean {
    return error instanceof HttpErrorResponse && error.status === HttpStatusCode.Unauthorized;
  }

  private isAuthFailedError(error: unknown): boolean {
    return (
      error instanceof HttpErrorResponse &&
      error.error.statusCode === HttpStatusCode.Unauthorized &&
      error.error.code === ErrorCode.AUTHENTICATION_FAILED
    );
  }
}
